import React, { Component } from 'react';
import { Icon } from 'antd';

class CotColorPicker extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (<>
            <input type="color"
                style={{ width: this.props.value || this.props.disabled ? 100 : 20 }}
                value={this.props.value}
                onChange={(e) => { this.props.onChange(e.target.value) }}
                disabled={this.props.disabled} />
            {this.props.disabled ? null : this.props.value ? (<Icon type="delete" onClick={() => { this.props.onChange("") }} />) : "בחר צבע"}
        </>);
    }
}

export default CotColorPicker;